var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.showIframe)?_c('SearchView',{on:{"navigate":_vm.updatePage}}):_vm._e(),_c('iframe',{ref:"iframe"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }